import axios from "axios";
import apiClient from "./ApiServices";
import apiIB from "./ApiServicesIB";
import TokenServices from "./TokenServices";

let isAlreadyFetchingAccessToken = false

function setup(store) {

    //Block Where Errors Running
    apiClient.interceptors.response.use(
        function (response) {
            return response
        },
        responseError
        
    )

    apiClient.interceptors.request.use(
        requestSuccess
    )

    //Block Where Errors Running
    apiIB.interceptors.response.use(
        function (response) {
            return response
        },
        responseError
        
    )

    apiIB.interceptors.request.use(
        requestSuccess
    )
    
    function requestSuccess (config) {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers.common['Authorization'] = `Bearer ${token}`
        }

        return config
    }

    async function responseError(error) {
        const originalRequest = error.config
        let responseMessage = error.response.data.message
        let rememberMe = localStorage.getItem('remember')
    
        if (error.response.status == 401) {
            console.log("mebebebe");
            
            if (responseMessage == "Token is blacklisted") {
                console.log("adkakfnakfna");
                //Return To Login if user is inactive
                return store.dispatch('logout')
            }
            if (responseMessage == "Token is invalid or expired") {
                return store.dispatch('tokenInvalid')
            }
    
            if (responseMessage == "User is inactive") {
                //Return To Login if user is inactive
                return store.dispatch('logout')
            }
    
            if (rememberMe == 'true') {
                //Refresh IF Remember Me
                if (!isAlreadyFetchingAccessToken) {
                    //Set Fetching Status to True to Prevent Infinte Loop When Error
                    isAlreadyFetchingAccessToken = true
                    //Taking Refresh Token From Storage in ./Services/TokenService
                    const refresh = TokenServices.getLocalRefreshToken()
    
                    //Send Refresh Token
                    const data = new FormData()
                    data.append('refresh', refresh)
                    try {
                        await axios.post(`${process.env.VUE_APP_CORPORATE_BASE_URL}auth/refresh/`, data).then((res)=>{
                            console.log(res);
                            TokenServices.updateLocalAccessToken(res.data.data.access_token, res.data.data.refresh)
                            isAlreadyFetchingAccessToken = false
                        }).catch((err)=>{
                            if(err.response.data.message === 'Token is blacklisted'){
                                localStorage.removeItem("token");
                                localStorage.removeItem("refresh");
                                localStorage.removeItem("remember");
                            }
                        })
                    } catch (error) {
                        console.log(error.data.message);
                    }
                }
    
                //Run the Previous Request to The Server again after getting new Access Token
                const retryOriginalRequest = new Promise((resolve) => {
    
                    originalRequest.headers.Authorization = 'Bearer ' + TokenServices.getLocalAccessToken()
                    resolve(apiClient(originalRequest))
    
                })
    
                return retryOriginalRequest
            }
            else if (rememberMe == 'false') {
                //Logout IF Not Remember Me
                store.dispatch('logout')
            }
        }
    
        return Promise.reject(error.response);
    }
}



export default setup